export const keys = [
    { value: "0", label: "0" },
    { value: "1#", label: "1#" },
    { value: "2#", label: "2#" },
    { value: "3#", label: "3#" },
    { value: "4#", label: "4#" },
    { value: "5#", label: "5#" },
    { value: "6#", label: "6#" },
    { value: "7#", label: "7#" },
    { value: "1b", label: "1b" },
    { value: "2b", label: "2b" },
    { value: "3b", label: "3b" },
    { value: "4b", label: "4b" },
    { value: "5b", label: "5b" },
    { value: "6b", label: "6b" },
    { value: "7b", label: "7b" },
];